function openCustomModal(html) {
  var modal = document.getElementById('CustomModal');
  if (!modal) {
    modal = document.createElement('div');
    modal.id = 'CustomModal';
    modal.innerHTML = '<div class="custom-modal__overlay"></div><div class="custom-modal__content"></div>';
    document.body.appendChild(modal);
    modal.querySelector('.custom-modal__overlay').addEventListener('click', function () {
      modal.classList.remove('is-open');
    });
  }
  modal.querySelector('.custom-modal__content').innerHTML = html;
  modal.classList.add('is-open');
}